<template>
  <div v-if="show">
    <!-- pc的toast -->
    <div :style="position" class="back" v-if="!isMobile">
      <div class="toast-wrap">
        <span>{{ text }}</span>
      </div>
    </div>
    <!-- mobile的toast -->
    <div :style="position" v-if="isMobile" class="back-h5">
      <div class="toast-wrap-h5">
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import ForceLandscape from "../../components/layout/ForceLandscape";
import store from "../../store";

export default {
  data() {
    return {
      show: false,
      text: "Success",
      type: "success",
      forceLandscape: 0,
      isMobile: store.getters.device.isMobile,
      position: {top:0, left:0},
    };
  },

  watch: {
    position(newName, oldName) {
      console.log(newName)
    }
  } 
  // components: {
  //   ForceLandscape,
  // },
};
</script>

<style lang="less" scoped>
.back {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  z-index: 9999999999;
  justify-content: center;
}
.toast-wrap {
  min-width: 200px;
  height: 40px;
  margin-top: 100px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animateShow 0.4s;
  padding: 0 20px;

  .toast-icon-success {
    height: 26px;
    width: 26px;
    background-image: url("../../assets/login/success.png");
    background-size: cover;
  }

  .toast-icon-error {
    height: 26px;
    width: 26px;
    background-image: url("../../assets/login/fail.png");
    background-size: cover;
  }

  span {
    font-size: 14px;
    color: #0c171f;
    font-family: Verdana;
  }
}
.back-h5 {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  z-index: 9999999999;
  justify-content: center;
}
// 横屏状态，组件旋转90度
.back-h5-landscape {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 9999999999;
  justify-content: center;
  width: 100vh;
  height: 100vw;
  top: 0;
  left: 100vw;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  transform-origin: 0% 0%;
}
.toast-wrap-h5 {
  min-width: 40vmin;
  height: 10vmin;
  margin-top: 10vmin;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animateShow 0.4s;
  padding: 0 2vmin;

  .toast-icon-success-h5 {
    height: 4vmin;
    width: 4vmin;
    background-image: url("../../assets/login/success.png");
    background-size: 100% 100%;
  }

  .toast-icon-error-h5 {
    height: 4vmin;
    width: 4vmin;
    background-image: url("../../assets/login/fail.png");
    background-size: 100% 100%;
  }

  span {
    font-size: 4vmin;
    color: #0c171f;
    font-family: Verdana;
  }
}
@keyframes animateShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
